module.exports = __webpack_public_path__ + "media/video-residence.e8e0ab20.mp4";